// extracted by mini-css-extract-plugin
export default {"gridItem":"Serie_gridItem__GhPoG"};